import Vue from 'vue'
import moment from 'moment'

Vue.filter('date', function (date, format) {
  return moment(date).format(format)
})
